const ShippingDelivery = () => {
	return (
		<>
			<section className="contact py-80">
				<div className="container container-lg">
					<div className="row gy-5">
						<div className="col-lg-12">
							<div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
								<h4 className="text-bold headingsize">
									Shipping/Delivery/
									<span className="primecolor">Pick-up Policy</span>
								</h4>
								<ul className="mt-20">
									<li className="text-md text-gray-900 mb-14">
										Udemandme.com presently focusing on the client base from UAE
										only. If anything required by any client from outside UAE,
										the shipment cost and other cost will be intimated to the
										client along with the delivery tentative schedule.
									</li>
								</ul>
								<h6 className="mt-24">
									All deliveries will be made through the following methods:
									<span className="primecolor px-5"></span>
								</h6>
								<ul className="mt-20">
									<li className="d-flex align-items-start gap-8 mb-20">
										<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
											<i className="ph ph-check icon-s"></i>
										</span>
										<span className="text-heading fw-medium">
											{" "}
											By their own vehicles
										</span>
									</li>
									<li className="d-flex align-items-start gap-8 mb-20">
										<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
											<i className="ph ph-check icon-s"></i>
										</span>
										<span className="text-heading fw-medium">
											By reputed courier companies
										</span>
									</li>
								</ul>

								<ul className="mt-20">
									<li className="text-md text-gray-900 mb-14">
										Deliveries, if material in stock, will be made within 1 to 7
										working days of the receipt of payment/order confirmation.
									</li>
									<li className="text-md text-gray-900 mb-14">
										All delivery charges are included in the invoice. If any
										extra delivery charges are applicable, they will be
										intimated to the client by email/WhatsApp, and only after
										confirmation from the client will the order be processed.
									</li>
								</ul>
								<h6 className="title text-lg fw-semibold mt-12 mb-8 mt-24 ps-20">
									Delivery Time: <span className="primecolor"> </span>
								</h6>
								<ul className="ps-20">
									<li className="d-flex align-items-start gap-8 mb-20">
										<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
											<i className="ph ph-check icon-s"></i>
										</span>
										<span className="text-heading fw-medium">
											Within UAE: Within 1 to 7 working days
										</span>
									</li>
									<li className="d-flex align-items-start gap-8 mb-20">
										<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
											<i className="ph ph-check icon-s"></i>
										</span>
										<span className="text-heading fw-medium">
											Outside UAE: Will be intimated by email/WhatsApp after
											discussing with courier/cargo agents.
										</span>
									</li>
								</ul>
								<ul className="mt-20">
									<li className="text-md text-gray-900 mb-14">
										Shipment cost (if any) will be intimated to the buyer by
										WhatsApp or on checkout of the cart. Our working time is to
										be considered from Thursday to Saturday (8:00 AM to 6:00
										PM). Friday and public holidays declared by the government
										will be considered as holiday.
									</li>
								</ul>
								<h6 className="title text-lg fw-semibold mt-12 mb-8 mt-24 ps-20">
									For any instance: <span className="primecolor"></span>
								</h6>
								<ul className="ps-20">
									<li className="d-flex align-items-start gap-8 mb-20">
										<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
											<i className="ph ph-check icon-s"></i>
										</span>
										<span className="text-heading fw-medium">
											If the material becomes out of stock, then the client will
											be intimated immediately within 6 working hours by
											WhatsApp or email.
										</span>
									</li>
									<li className="d-flex align-items-start gap-8 mb-20">
										<span className="text-xl d-flex flex-shrink-0 align-items-center justify-content-center rounded-circle prime-icon">
											<i className="ph ph-check icon-s"></i>
										</span>
										<span className="text-heading fw-medium">
											If the material delivery will take more than the normal
											delivery period, the client will be intimated. Upon
											client’s approval, only then the order will be processed.
											Else, the client has the option to cancel the order, and
											the amount of the cancelled order will be returned in the
											same mode of payment as stated in the Return/Refund Policy
											from the date of cancelling the order.
										</span>
									</li>
								</ul>
								<h6 className="title text-lg fw-semibold mt-12 mb-8 mt-24 ">
									Multiple Shipment / Orders /{" "}
									<span className="primecolor">Bookings</span>
								</h6>
								<ul className="mt-20">
									<li className="text-md text-gray-900 mb-14">
										The multiple booking/orders/shipments may result in multiple
										postings to the cardholder’s monthly statement.
									</li>
								</ul>
								<h6 className="title text-lg fw-semibold mt-12 mb-8 mt-24 ">
									We do not accept multiple bookings or orders.
									<span className="primecolor"></span>
								</h6>
								<h6 className="title text-lg fw-semibold mt-12 mb-8 mt-24 ">
									{" "}
									<span className="primecolor">Very Important NOTE:</span>
								</h6>

								<ul className="mt-20">
									<li className="text-md text-gray-900 mb-14">
										Customer can request disputes or chargeback within 1 month
										of receipt of order. Please keep proof of delivery receipt
										signed and other necessary documents.
									</li>
									<li className="text-md text-gray-900 mb-14">
										If the client wants to use our express delivery service, it
										will be extra. The cost will be informed by WhatsApp or
										email after specifying the location it is needed. We will
										try to make it available to you within 24 hours irrespective
										of holidays.
									</li>
									<li className="text-md text-gray-900 mb-14">
										Delivery of the goods normally will be from 10:00 AM to 7:00
										PM.
									</li>
									<li className="text-md text-gray-900 mb-14">
										Any order processed after 4:00 PM will be taken as next day
										order.
									</li>
									<li className="text-md text-gray-900 mb-14">
										Any shipment cost will be intimated to the client and the
										material for delivery will be intimated to the client 6
										hours before delivery.
									</li>
									<li className="text-md text-gray-900 mb-14">
										Client has to give the nearby best-known location of
										delivery, for fast delivery of goods. If the client is
										having any query about delivery, then against the order they
										can forward their request by WhatsApp or email.
									</li>
									<li className="text-md text-gray-900 mb-14">
										Cash / Credit Card / Cheque to be delivered against delivery
										before opening the boxes. For any query about material, the
										customer can contact our contact center and their query will
										be attended to as soon as possible.
									</li>
									<li className="text-md text-gray-900 mb-14">
										In case of bulky material, the unloading of the material at
										the site will be the responsibility of the client at their
										own cost. Any breakage during unloading will be treated as
										sold and will not be returned. For any return of the bulky
										material, the client has to bear the shipment cost and
										loading cost.
									</li>
									<li className="text-md text-gray-900 mb-14">
										If the customer wants to avail our service for pickup of the
										machine or delivery at the authorized service center, then
										we are there to help you with some extra charges. The
										charges will be intimated to the client on request, and if
										approved, then the service will be made as required.
									</li>
									<li className="text-md text-gray-900 mb-14">
										If you have any suggestion, please feel free to contact us
										and WhatsApp us your suggestion also.
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};
export default ShippingDelivery;
